//@flow
import React, { type Element, Component } from 'react';
import { RequiresActionP, CustomBlueTextLink } from './PaidStyles';
import { connect } from 'react-redux';
import { hideTooltip } from '../../../reducer';

type Props = {
  currencyName: string,
  currencyType: string,
  status: string,
  requiresCryptoWallet: boolean,
  requiresBankAccount: boolean,
  handleRequiresAction: Function => Element<any>,
  defaultRender?: Element<any>,
  hideTooltip?: () => void
};
class RequiresAction extends Component<Props> {
  handleClick = () => (event: SyntheticInputEvent<any>) => {
    this.props.hideTooltip && this.props.hideTooltip();
    event.stopPropagation();
  };
  handleCrypto = (status: string) => {
    switch (status) {
      case 'pending':
        return (
          <RequiresActionP>
            Please add a
            <CustomBlueTextLink
              exact
              to="/account/crypto-wallets"
              onClick={this.handleClick()}
            >{`${this.props.currencyName} wallet address`}</CustomBlueTextLink>
            so that we can send you the funds once your payout is ready.
          </RequiresActionP>
        );
      default:
        return (
          <RequiresActionP>
            The payout is ready to be sent. Please add a
            <CustomBlueTextLink
              exact
              to="/account/crypto-wallets"
              onClick={this.handleClick()}
            >{`${this.props.currencyName} wallet address`}</CustomBlueTextLink>
            so that we can send you the funds.
          </RequiresActionP>
        );
    }
  };

  handleFiat = (status: string) => {
    switch (status) {
      case 'pending':
        return (
          <RequiresActionP>
            Please add a
            <CustomBlueTextLink
              exact
              to="/account/bank-account"
              onClick={this.handleClick()}
            >
              bank account
            </CustomBlueTextLink>
            so that we can send you the funds once your payout is ready.
          </RequiresActionP>
        );
      default:
        return (
          <RequiresActionP>
            The payout is ready to be sent. Please add a
            <CustomBlueTextLink
              exact
              to="/account/bank-account"
              onClick={this.handleClick()}
            >
              bank account
            </CustomBlueTextLink>
            so that we can send you the funds.
          </RequiresActionP>
        );
    }
  };

  render() {
    const status = this.props.status.toLowerCase();
    const requiresCryptoWallet =
      this.props.requiresCryptoWallet && this.props.currencyType === 'crypto';
    const requiresBankAccount =
      this.props.requiresBankAccount && this.props.currencyType === 'fiat';

    if (requiresCryptoWallet) {
      return this.props.handleRequiresAction(this.handleCrypto(status));
    } else if (requiresBankAccount) {
      return this.props.handleRequiresAction(this.handleFiat(status));
    } else {
      return this.props.defaultRender || <div />;
    }
  }
}

const mapDispatchToProps = {
  hideTooltip
};

export default connect(null, mapDispatchToProps)(RequiresAction);
